(() => {
  if (window.WheelSizeOptions) return;
  const nameOf = input => input.name.replace(/^options\[/, '').replace(/\]$/, '');
  function create(picker, variants, usable) {
    const names = [...new Set([...picker.querySelectorAll('input[type="radio"],select')].map(nameOf))];
    const controls = name => [...picker.querySelectorAll('input[type="radio"],select')].filter(input => nameOf(input) === name);
    const value = name => controls(name).find(input => input.tagName === 'SELECT' || input.checked)?.value || '';
    const choose = (name, selected) => controls(name).forEach(input => { if (input.tagName === 'SELECT') input.value = selected; else input.checked = input.value === selected; });
    function refresh() {
      let candidates = variants;
      names.forEach((name, index) => {
        const available = candidates.filter(usable);
        const allowed = new Set(available.map(variant => String(variant.options[index])));
        if (!allowed.has(value(name)) && available.length) choose(name, String(available[0].options[index]));
        for (const input of controls(name)) {
          const inputs = input.tagName === 'SELECT' ? [...input.options] : [input];
          for (const item of inputs) {
            const possible = candidates.filter(variant => String(variant.options[index]) === item.value);
            const disabled = !allowed.has(item.value);
            const reason = possible.length ? 'Requires price or fitment confirmation' : 'Unavailable with the selected options';
            item.hidden = false; item.disabled = disabled;
            item.classList.toggle('disabled', disabled);
            item.setAttribute('aria-disabled', String(disabled));
            item.title = disabled ? reason : '';
            if (input.tagName !== 'SELECT') {
              const box = input.closest('.product-form__item');
              if (box) { box.hidden = false; box.title = disabled ? reason : ''; }
            }
          }
        }
        candidates = candidates.filter(variant => String(variant.options[index]) === value(name));
      });
    }
    refresh(); picker.wheelSizeOptions = { refresh }; return picker.wheelSizeOptions;
  }
  window.WheelSizeOptions = { create };
})();
